import React from 'react';
import styles from './Index.module.css';

const LoadingState = () => {
    return (
        <div className={styles.pageContainer}>
            <div className={styles.loadingContainer}>
                <div className={styles.loadingSpinner}>
                    <svg className={styles.spinner} viewBox="0 0 50 50">
                        <circle className={styles.spinnerPath} cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                    </svg>
                </div>
                <p className={styles.loadingText}>Loading survey...</p>
                <p className={styles.loadingSubtext}>Please wait while we prepare your survey</p>
            </div>
        </div>
    );
};

export default LoadingState;